import { clinicHasRequestedSpecialty } from 'pages/results/helpers/specialty-helpers';

export const GtmDataLayerEvent = Object.freeze({
  SEARCH_QUESTION_WELCOME_REACHED: 'questionWelcomeReached',
  SEARCH_QUESTION_ATTITUDE_REACHED: 'questionAttitudeReached',
  SEARCH_QUESTION_INSURANCE_REACHED: 'questionInsuranceReached',
  SEARCH_RESULTS_REACHED: 'matchResultsReached',
  APPOINTMENT_CHECKOUT_ACCOUNT_CREATED: 'appointmentCheckoutAccountCreated',
  APPOINTMENT_CHECKOUT_ACCOUNT_VERIFIED: 'appointmentCheckoutAccountVerified',
  PATIENT_INFO_SUBMITTED: 'patientInfoSubmitted',
  INSURANCE_INFO_SUBMITTED: 'insuranceInfoSubmitted',
  APPOINTMENT_REQUESTED: 'appointmentRequested',
});

export const trackGtmDataLayerEvent = (eventName, variables = {}) => {
  if (eventName) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: eventName,
      ...variables,
    });
  }
};

export const getSpecialistAnalyticsData = (match, results) => {
  const customProperties = {
    did_select_specialty: String(match?.other?.triageResponse === 'specialist'),
    selected_specialties: String(
      match?.other?.specialistData?.specialistTypes?.map((s) => s.id).join(','),
    ),
    has_referral: String(match?.other?.specialistData?.hasReferral),
  };

  if (results?.length) {
    customProperties.num_results_with_matching_specialty = String(
      results.filter((clinic) => clinicHasRequestedSpecialty({ clinic, match }))
        .length,
    );
  }

  return customProperties;
};
